import { TQC2090_R01_LINE_OPTIONS } from "../Dto_TQC2090_R01";

export const TQC2090_R01_TABS = TQC2090_R01_LINE_OPTIONS;

export const getTQC2090_R01ColumnStateKey = (workplaceCd: string): string =>
	`TQC2090_R01-${workplaceCd}-grid-column-state`;
